module.exports = __webpack_public_path__ + "img/hn.e0101f96.svg";